export class PaymentPayload {
  constructor(
    public ApplicationID?: string,
    public FirstName?: string,
    public MiddleName?: string,
    public LastName?: string,
    public ContactEmailAddress?: string,
    public StreetName1?: string,
    public StreetName2?: string,
    public State?: string,
    public CityName?: string,
    public ZipCode?: string,
    public payment?: object,
    public Region?: string,
    public Platform?: string
  ) { }
}

export class PaymentDetailObj {
  constructor(
    public pmtMthd?: string,
    public pmtAmt?: string,
    public ccNum?: string,
    public ccExp?: string,
    public ccCode?: string,
    public pmtMthdType?: string,
    public achRtNum?: string,
    public achAcctNum?: string,
    public dbType?: string,
    public Region?: string,
    public Platform?: string,
    public firstNameBankAcct?: string,
    public lastNameBankAcct?: string,
    public custEmail?: string,
    public custDOB?: string,
    public accountHolderType?: string,
    public businessNameBankAcct?: string,
    public securityCode?: string
  ) { }
}

export class ACHPaymentDetailObj implements PaymentDetailObj {
  constructor(
    public pmtMthd?: string,
    public pmtMthdType?: string,
    public pmtAmt?: string,
    public achRtNum?: string,
    public achAcctNum?: string
  ) { }
}

export class CCPaymentDetailObj implements PaymentDetailObj {
  constructor(
    public pmtMthd?: string,
    public pmtAmt?: string,
    public ccNum?: string,
    public ccExp?: string,
    public ccCode?: string,
    public dbType?: string
  ) { }
}

export class AdverseDetailObj {
  constructor(
    public firstName?: string,
    public lastName?: string,
    public email?: string,
    public addressLine1?: string,
    public addressLine2?: string,
    public city?: string,
    public state?: string,
    public postalCode?: string,
    public channel?: string,
    public letterType?: string,
    public referenceId?: string,
    public merchantId?: string,
    public productCode?: string,
    public screen?: string,
    public acctName?: string,
    public userId?: string,
    public companyName?: string,
    public language?: string,
    public applicationId?: string
  ) { }
}
